var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard5B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32__1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M375,334.2c-2,0-4,0-6,0.3c-2.7,0.4-1.9,3.9-1.8,5.9c0,1.7-0.4,4.4,1.4,5.3c1.8,1,5.2,0.5,7.2,0.7 c9.8,1,18.7,0.6,27.5,3.2c2,0.6,4,1.4,5.9,2.4c1.3,0.7,5.1,3.6,6.6,3.2c3.3-0.7-5.2-8.9-6.5-10.1c-7.6-6.8-16.4-9.7-26.4-10.6 C380.3,334.3,377.6,334.3,375,334.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M346.4,335.3c2,0,4-0.1,6,0.1c2.8,0.3,2,3.8,2,5.8c0,1.7,0.6,4.4-1.2,5.4c-1.8,1-5.2,0.6-7.2,0.9 c-9.7,1.3-18.7,1.3-27.4,4.1c-2,0.7-4,1.5-5.8,2.5c-1.3,0.7-5,3.7-6.5,3.5c-3.3-0.6,4.9-9.1,6.1-10.3c7.3-7,16.1-10.2,26-11.5 C341.1,335.6,343.7,335.5,346.4,335.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M334.4,425.5L334.4,425.5L334.4,425.5C334.3,425.6,334.3,425.6,334.4,425.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M397.6,391c-4.8,2.6-10.4,3.9-15.6,4.7c-5.8,0.9-14.2-1.1-19.9-1.5c-6.1-0.4-9.8,0.5-15.5,1.8 c-5.6,1.3-10.3,2.5-16,0.9c-5-1.4-9.7-3.5-14.6-5.6c-4-1.7-8-3.4-11.6-5.6c3.4,3.5,5.1,8.3,8.3,12c3.4,4,7.2,7,10.2,11.4 c2.2,3.3,5,6,4.6,10.4c2.6-2.9,3.6-5,3.1-8.8c2.9,2.7,5.1,11.1,3.8,14.9c3.5-1.9,6-4.4,7.4-8c0.7,3.9,0,9.4-2.9,12.5 c3.9-0.9,9.4-3.7,11.3-7.7c0.9,6.6,2.3,10.3,8.5,14.1c4-4,8.8-6.8,11.2-12.6c0.8,3.4,1.3,6.6,4.8,8.4c-0.6-4.5,0.6-10.7,1.8-15 c0.2,3.3,1.3,6.5,3.8,8.8c1.2-4.6,5.6-9.2,8.7-12.8c3.5-3.9,6.7-8,10.2-11.9c2.6-2.8,5-5.8,7.3-8.8c1.5-1.9,4.6-5.6,5.5-7.1 C405.4,386.9,402.3,388.4,397.6,391z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard5B);
export default __webpack_public_path__ + "static/media/man_beard_5b.604a2428da045b07ca601e61c733d3d4.svg";
export { ForwardRef as ReactComponent };